import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ kicker, title, desc, align = "right" }) => (
  <div className={align === "center" ? "text-center" : ""}>
    <div className={`flex items-center gap-3 mb-4 ${align === "center" ? "justify-center" : ""}`}>
      <span className="h-px w-10 bg-yellow-400" />
      <span className="text-yellow-400 text-sm font-semibold tracking-wide">{kicker}</span>
    </div>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white leading-snug">
      {title}
    </h2>
    {desc && <p className="mt-4 text-base text-zinc-400 leading-relaxed max-w-2xl">{desc}</p>}
  </div>
);

export { EASE };
